import { IconButton, IconButtonProps } from '@material-ui/core'
import { ReactComponent as BackArrowIconDark } from 'icons/mobile-back-button-icon-dark.svg'
import { ReactComponent as BackArrowIconLight } from 'icons/mobile-back-button-icon-light.svg'
import { useThemeSwitch } from 'hooks/theme'

export const MobileBackButton = (props: IconButtonProps) => {
  const { mode } = useThemeSwitch()

  return <IconButton {...props}>{mode === 'dark' ? <BackArrowIconLight /> : <BackArrowIconDark />}</IconButton>
}
